import React from "react";
import Chart from "react-apexcharts";
import { formatDateForPeriod, getFormattedData } from "../dateUtils";
import { transformChartData } from "../charthelper";

const AreaChart = ({ chartUtils, colors }) => {
  const combinedData = chartUtils?.series?.flatMap((seriesItem, seriesIndex) =>
    chartUtils?.category?.map((date, index) => ({
      date,
      value: seriesItem?.data?.[index] || 0,
      name: seriesItem.name, // To differentiate series
    }))
  );

  const formattedData = getFormattedData(
    combinedData || [],
    chartUtils?.chart_period || "daily"
  );

  const options = {
    chart: {
      type: "area",
      stacked: true,
      autoScale: true,
      animations: {
        enabled: true,
        easing: "easeinout",
        speed: 800,
        animateGradually: {
          enabled: true,
          delay: 150,
        },
        dynamicAnimation: {
          enabled: true,
          speed: 500,
        },
      },
    },
    stroke: {
      curve: "smooth",
      width: 2,
    },
    xaxis: {
      type: "datetime",
      labels: {
        rotate: -45,
        datetimeUTC: false,
        text: chartUtils?.axis?.x || "Date",
      },

    },
    fill: {
      colors: colors || [
        chartUtils?.colors?.[chartUtils?.series[0]?.name] || "#008FFB",
      ],
      type: "gradient",
      gradient: {
        shadeIntensity: 0.5,
        opacityFrom: 0.7,
        opacityTo: 0.9,
        stops: [0, 90, 100],
      },
    },

    grid: {
      borderColor: "#F1F1F1",
      strokeDashArray: 5,
    },
    dataLabels: {
      enabled: false,
    },
    yaxis: {
      title: {
        text: chartUtils?.axis?.y || "Value",
      },
      labels: {
        formatter: (value) => value.toFixed(2),
      },
    },
  };

  const series = formattedData.seriesData || [];
   return (
    <>
      <Chart
        options={options}
        series={transformChartData(formattedData.categories, series)}
        type="area"
        height={350}
        width={"100%"}
      />
    </>)

};

export default AreaChart;
